import { Container, Carousel } from "react-bootstrap"
import styled from 'styled-components'
import { useMemo, useState } from "react"
import { useTranslation } from 'react-i18next'
import Text from '~/components/Text'
import Box from "~/components/Box"
import Button from "~/components/Button"
import Icon from '~/components/Icon'
import getSteps from "./content"
import ModalVideo from "~/components/UI/ModalVideo"
import { emitGA } from "~/utils/gtm"
import { ROUTES } from "~/constant"
import Img from "~/components/UI/Image"


const MyContainer = styled(Container)`
  background-color: #010413;
  height: 770px;
  padding-top: 32px;
  padding-bottom: 32px;
  .carousel-indicators {
    top: 360px;
  }
  display: block;
  @media (min-width: 767.99px) {
    display: none
  }
`


const ImgContainer = styled.div`
  width: auto;
  height: 376px;
  text-align: center;
`

const PlayIcon = styled.div`
  background-color: #fff;
  height: 24px;
  width: 24px;
  padding-left: 2px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  span {
    font-size: 18px;
  }
`

interface Item {
  img: string
  title: string
  desc: string
}

const Step: React.FC<Item> = ({
  img,
  title,
  desc
}) => {
  return (
    <Box flex column justify='center' padding='0 10px'>
      <ImgContainer>
        <Img height={376} width={209} className='intro-step1' src={img} alt="intro-step1" />
      </ImgContainer>
      {/* ========== step 1 ============== */}
      <Text centered lineHeight='normal' bold size={36} color='white'>
        {title}
      </Text>
      <Text centered style={{ marginTop: 16 }} color='white'>
        {desc}
      </Text>
    </Box>
  )
}

const MobileIntro = () => {

  const [t] = useTranslation()
  const Items = useMemo(() => getSteps(t), [t])

  const renderItems = () => {
    return Items.map(item => <Carousel.Item key={item.title}><Step {...item} /></Carousel.Item>)
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (evt: any) => {
    evt.preventDefault();
    emitGA('Homepage', { label: 'Start', action: 'VideoPlay' })
    setShow(true);
  }


  return (
    <MyContainer>
      <ModalVideo src='https://www.youtube.com/embed/HHddbnpdO9U' show={show} onHide={handleClose} />
      <Box height='600px' className='intro-carousel'>
        <Carousel interval={null} controls={false}>
          {renderItems()}
        </Carousel>
      </Box>
      <Box padding='0 10px'>
        <Box height='auto' padding='0 0 8px 0'>
          <Button margin='16px auto' style={{ marginTop: 0 }} href={ROUTES.REAL_ESTATE_INTRODUCTION} link color='white' primary>
            <Text color='#fff'>
              {t`Mô Hình Đầu Tư`}
            </Text>
          </Button>
          <Button margin='auto' onClick={handleShow} link borderColor='#fff'>
            <PlayIcon>
              <Icon style={{ transform: 'rotate(-90deg' }} name='drop-down' />
            </PlayIcon>
            <Text color='#fff'>
              {t`Xem Video`}
            </Text>
          </Button>
        </Box>
      </Box>
    </MyContainer>
  )
}

export default MobileIntro